export const getPersonalizedStoryDescription = (story) => {
  const description = story?.description;

  if (typeof description !== "string" || description.trim().length === 0) {
    return description || "";
  }

  const isTemplateStory =
    story?.template_id !== null &&
    story?.template_id !== undefined &&
    story?.template_id !== "";

  if (!isTemplateStory) {
    return description;
  }

  const characterName = story?.characters?.[0]?.name || "a child";

  // Personalize template defaults at render-time without mutating story data.
  return description.replace(/\b(Luna|boy|girl)\b/gi, characterName);
};
